import { Icon, IconProps } from './Icon';

export const ExpandIcon = ({ ...props }: IconProps) => (
  <Icon
    {...props}
    viewBox="0 0 32 32"
  >
    <rect
      x="-0.5"
      y="0.5"
      width="31"
      height="31"
      rx="15.5"
      transform="matrix(-1 0 0 1 31 0)"
      fill="#FEFEFE"
    />
    <rect
      x="-0.5"
      y="0.5"
      width="31"
      height="31"
      rx="15.5"
      transform="matrix(-1 0 0 1 31 0)"
      stroke="#DADFE8"
    />
    <path
      d="M19.1667 16.0003H7.5"
      stroke="#798199"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M22.5002 9.33366V22.667"
      stroke="#798199"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M15 11.8338L19.1675 16.0013L15 20.168"
      stroke="#798199"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </Icon>
);
